exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2Z4EU1u2RRUueuR9a2UrrU{max-height:80vh;max-width:64.28571rem;overflow:hidden;overflow-y:scroll}", ""]);

// exports
exports.locals = {
	"InfoDialog": "_2Z4EU1u2RRUueuR9a2UrrU"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.3/node_modules/omni-common-ui/postcss.config.js"}}!./components/InfoDialog/style.postcss
// module id = 1436
// module chunks = 0